module.exports = __webpack_public_path__ + "static/img/left_logo_245x147.fb82d8a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left_logo_245x147.gif
// module id = jehY
// module chunks = 43